import { z } from 'zod';

export const cropBatchItemSchema = z.object({
  clipId: z.number(),
  vaultPath: z.string(),
  startMs: z.number(),
  endMs: z.number(),
  outputFilename: z.string(),
});

export const cropBatchRequestSchema = z.object({
  items: z.array(cropBatchItemSchema).min(1),
});

export type ICropBatchItem = z.infer<typeof cropBatchItemSchema>;
export type ICropBatchRequest = z.infer<typeof cropBatchRequestSchema>;
